import styled from 'styled-components';

// const LoginTop = styled.div`
//     background: #F7F7F7; /* Bar color */
//     padding: 15px 65px 5px;
//     border-radius: 10px 10px 0px 0px;
//     text-align: center;
//     color: #4A4A4A; /* Updated font color for claims login */
//     font-family: 'Omnes', sans-serif; /* Claims login font */
//     font-size: 24px; /* Font size */
//     font-weight: 600; /* Semibold weight */
// `;

const LoginTop = styled.div`
    background: #031c30;
    padding: 15px 65px 5px;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    color: #eff0f3;
`;

export default LoginTop;



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginTop/index.js